let navigateFunction: (
  to: string,
  options?: { replace?: boolean; state?: any }
) => void;

export const setNavigate = (
  navigate: (to: string, options?: { replace?: boolean; state?: any }) => void
) => {
  navigateFunction = navigate;
};

export const redirectTo = (
  path: string,
  options?: { replace?: boolean; state?: any }
) => {
  if (navigateFunction) {
    navigateFunction(path, options);
  } else {
    console.error('Navigate function is not set!');
  }
};
